import { LodgingBase } from '../json-schemas/base/lodging'
import { I18nService } from '../utils/i18n.service'

const i18nScoped = new I18nService(require('./lodgings.service.yml'))

export function lodgingI18nIcalProvider (icalProvider: LodgingBase['ical_provider']) {
  return i18nScoped.t(`ical_provider.${icalProvider}`)
}

export function lodgingI18nIcalValidationError (validationError: string) {
  return i18nScoped.t(`ical_url_errors.${validationError}`)
}
